import { findLast, get } from 'lodash';
export const findMatchMedia = (matchMedias) => get(findLast(matchMedias, ({ matchMedia }) => matchMedia === null || matchMedia === void 0 ? void 0 : matchMedia.matches), 'breakpoint', 's');
//# sourceMappingURL=findMatchMedia.js.map